import { get, post } from "../AxiosConfig";
import { createCRUDService } from "./createCRUDService";

const AgentService = createCRUDService("agent", {
  listAgent: "list-agent",
  updateAgent: "update-agent",
  deleteAgent: "delete-agent",
  bankAffiliation: "add-agent-bankdetail",
  bankAffiInfo: "bank-accounts",
});

// Casponet config endpoints (GET + POST)
AgentService.getCasponetConfig = (agentId) => {
  return get(`/agent/casponet-config?agentId=${agentId}`);
};

AgentService.saveCasponetConfig = (payload) => {
  return post("/agent/casponet-config", payload);
};

AgentService.createOrRefreshToken = (payload) => {
  return post("/agent/casponet-token", payload);
};

export default AgentService;
